export default __webpack_public_path__ + "static/media/servicenow.842939e1.svg";